import React from 'react'
import SideRightContent from '../components/auth/SideRightContent'
import Footer from '../components/auth/Footer'
import icons from '../icons';
import { Link } from 'react-router-dom';
import {ErrorBoundary} from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import OrganizaitionSignin from '../components/auth/OrganizaitionSignin';
import { getCsrfToken } from "../services/authApiRoutes/APImethods";
import $ from "jquery";
export default function OrganizationLogin() {
    const { t, i18n } = useTranslation();
	const inputRef  = React.createRef(null);
    function ErrorHandler({error}) {
		return (
		  <div role="alert">
			<p>An error occurred:</p>
			<pre>{error.message}</pre>
		  </div>
		)
	  }
      const executeScroll = (e) => {
		e.preventDefault();
		if(e.key === "Enter"){
			$('#inputEmail').trigger('focus');
		}
		$('#inputEmail').trigger('focus');
	  } 
  return (
    <div className="wrapper">
			 <div role="link" tabIndex={0} onClick={executeScroll} onKeyDown={(e)=>executeScroll(e)} className="skip"><span>Skip to Main Content</span></div>
			<div className="sign-page">
			<div className="right-dot"></div>
			<div className="content" >
				<div className="flex-warp-block">
					<div className="container">
						<div className="logo hide"><Link to="#"><img src={icons.LOGO_LOGIN} alt="Logo" title="Logo" /></Link></div>
						<div className="sign-form">
						<div className="form-heading">
							<h1>{t('sign_in')}</h1>
								<p>{t('login_form_subtitle')}</p>
						</div>
							<ErrorBoundary FallbackComponent={ErrorHandler}>
								<OrganizaitionSignin />
							</ErrorBoundary>	
						</div>
		
						<SideRightContent />
					</div>
				</div>
			</div>
			
			<Footer />
			
		</div>
	</div>
  )
}
